module.exports = {
    base_url: "https://captivateprime.adobe.com",
    app_back_end_url_token: "https://demoapi-captivateprime.harbingergroup.com/api/getToken?code=2/DbWv20taRmCZF/5p58igyn4wawgolilC0m5bvlUxiyMQP3TVocCw==",
    app_back_end_url_refresh_token: "https://demoapi-captivateprime.harbingergroup.com/api/getRefreshToken?code=BsABxVEa4ZvsrtT65JELJ9aYs053iv0mD9fb0oNW45VmP7D3y2/EsA==",
    front_end_app_url: "http://localhost:2000"//"https://harbingercaptivateprime.z13.web.core.windows.net"
}

// module.exports = {
//     base_url: "https://captivateprime.adobe.com",
//     app_back_end_url_token: "http://localhost:3001/v2/user/oauth/token",
//     app_back_end_url_refresh_token: "http://localhost:3001/v2/user/oauth/token/refresh",
//     front_end_app_url: "http://localhost:2000"//"https://harbingercaptivateprime.z13.web.core.windows.net"
// }